/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ControlcenterMelcoModelsCustomWarning,
    ControlcenterMelcoModelsCustomWarningFromJSON,
    ControlcenterMelcoModelsCustomWarningFromJSONTyped,
    ControlcenterMelcoModelsCustomWarningToJSON,
    ControlcenterMelcoModelsLocaleString,
    ControlcenterMelcoModelsLocaleStringFromJSON,
    ControlcenterMelcoModelsLocaleStringFromJSONTyped,
    ControlcenterMelcoModelsLocaleStringToJSON,
} from './';

/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsGenericList1MelcoModelsLocaleString
 */
export interface ControlcenterMelcoModelsGenericList1MelcoModelsLocaleString {
    /**
     * 
     * @type {Array<ControlcenterMelcoModelsLocaleString>}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoModelsLocaleString
     */
    list: Array<ControlcenterMelcoModelsLocaleString>;
    /**
     * 
     * @type {Array<ControlcenterMelcoModelsCustomWarning>}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoModelsLocaleString
     */
    warning_list?: Array<ControlcenterMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoModelsLocaleString
     */
    total: number;
}

export function ControlcenterMelcoModelsGenericList1MelcoModelsLocaleStringFromJSON(json: any): ControlcenterMelcoModelsGenericList1MelcoModelsLocaleString {
    return ControlcenterMelcoModelsGenericList1MelcoModelsLocaleStringFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsGenericList1MelcoModelsLocaleStringFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsGenericList1MelcoModelsLocaleString {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(ControlcenterMelcoModelsLocaleStringFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(ControlcenterMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function ControlcenterMelcoModelsGenericList1MelcoModelsLocaleStringToJSON(value?: ControlcenterMelcoModelsGenericList1MelcoModelsLocaleString | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(ControlcenterMelcoModelsLocaleStringToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(ControlcenterMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


